<style lang="scss" scoped>
@import "$vars";
@screen mobile {
  .section {
    @apply m-0 px-2 border-0 #{!important};
  }
  .card-body {
    @apply flex-col #{!important};
    >aside {
      @apply p-0 w-full border-r-0 #{!important};
      >header {
        @apply p-0 inline-block #{!important};
        >:first-child {
          @apply min-w-0 w-3/12 ml-3 float-left #{!important};
        }
        >pre, >button {
          @apply m-0 p-0 px-1 mr-2 float-right w-7/12 #{!important};
        }
      }
    }
    >section {
      @apply w-full;
      >main, >header {
        @apply p-2 #{!important};
      }
      >main>main {
        @apply p-0;
      }
    }
  }
}
.card-body {
  padding: 0 !important;
  margin: 0;
  > aside,
  > section {
    padding: 0.8rem;
  }
  > aside {
    border-right: 1px solid #e1e1e1;
    padding: 0 0.6rem;
    > header {
      padding: 1rem 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    figure {
      width: 50%;
      min-width: 100px;
      margin: 0 auto;
    }
    pre {
      margin-top: 10px;
      font-size: 1.5rem;
      text-align: center;
    }
    button {
      margin: 0;
      padding: 5px;
    }
    > nav ul {
      padding: 0;
    }
  }
  > section {
    padding: 0 0 40px 0;
    header {
      padding: 40px;
      hr {
        margin: 30px 0;
      }
    }
    main {
      padding: 0 20px;
    }
  }
}

.tab {
  background: #f1f1f1;
  border-left: 1px solid #e1e1e1;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-top: 1px solid #e1e1e1;
  border-right: 1px solid #e1e1e1;
  display: flex;
  flex: initial;
  font-size: 0.8em;
  font-weight: bold;
  justify-content: flex-start;
  margin: 0;
  padding: 0;
  text-transform: uppercase;

  &-item {
    box-sizing: border-box;
    color: #8E8E92;
    padding: 10px 50px;

    &:first-of-type {
      &.active {
        border-left: 0;
      }
    }

    &.active {
      background: #ffffff;
      border-bottom: 1px solid #ffffff;
      border-left: 1px solid #e1e1e1;
      border-right: 1px solid #e1e1e1;
      margin-bottom: -1px;
    }

    a {
      box-sizing: border-box;
      border: none;
      margin: 0;
      padding: 0;
    }
  }
}
.medical_request {
  >main {
    border: 1px solid #e1e1e1;
    border-top: 0;
    padding: 20px !important
  }
}
.btn-active {
  background: $color-green;
  color: white;
}

.teste {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
}
.personalData{
  strong.capitalize {
  text-transform: capitalize !important;
  }
}

.loader {
  align-content: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}

</style>

<template>
  <article class="section">
    <!-- <button v-if="false || broadCasting" class="telemedicine-window" @click="openTelemedicineNewTab()">
      Video em nova aba
    </button> -->

    <div v-if="loaded" class="card-body columns teste">
      <aside class="col-3">
        <header id="appointment-sidebar-header" v-if="hasAppointment && fn_IS_DOCTOR() && canStart">
          <dr-icon name="timer" :fill.sync="getIconFill"></dr-icon>

          <drTimer
            :appointmentId="appointment.id"
            @started="isActiveAppointment ? appointmentStarted = true : ''"
            @stopped="appointmentStarted ? (appointmentFinished = true) (appointmentStarted = false) : ''"
          />

          <!-- <button @click="toggleAppointment()" class="btn" :class="appointmentRun ? 'btn-active' : 'btn-primary' ">{{appointmentStarted ? ( appointmentRun ? 'Pausar' : 'Resumir' ) : 'iniciar'}} consulta</button> -->

          <button
            class="btn"
            @click="appointmentConfirm()"
            :disabled="appointment['medical_consultation_finish'] || appointmentFinished || isDisabled"
            :class="appointmentStarted ? 'btn-active' : 'btn-primary' "
          >
            <template v-if="isDisabled">
              <dr-loader size="sm" color="white" />
            </template>

            <template v-else>
              <template v-if="!appointment['medical_consultation_finish'] && !appointmentFinished">
                {{ appointmentStarted ? 'Concluir' : 'Iniciar' }} atendimento
              </template>

              <template v-else>
                Atendimento finalizado
              </template>
            </template>
          </button>
        </header>
        <appointmentReminder
          v-if="nextAppointment && !appointmentStarted"
          :next-appointment="nextAppointment"
        />

       <patientDetails
         v-if="fn_IS_MOBILE()"
         :doctor="doctor"
         :patient="patient"
         :appointment="appointment"
         :appointments="appointments"
         :hasAppointment="hasAppointment"
       />

        <nav v-if="hasAppointment && !appointment.medical_consultation_finish && appointmentStarted && fn_IS_DOCTOR()">
          <submenu
            :selected.sync="selectedComponent"
            :schedulingType.sync ="appointment.type"
            @change="selectComponent"
          />
        </nav>
      </aside>

      <section class="col-9">
        <header id="medical-record-header" style="position: relative;">
          <!-- Botão Iniciar consulta -->
            <button
              v-show="telemedicineButton"
              :disabled="isDisabled"
              id="telemedicine-btn-start"
              class="telemedicine__btn-start"
              @click="startTelemedicineAppointment()"
            >
              <template v-if="loadingTelemedicine">
                <dr-loader size="sm" color="white" />
              </template>

              <template v-else>
                <span>Iniciar consulta por vídeo</span>

                <dr-icon
                  name="startTelemedicine"
                  fill="white"
                  class="telemedicine__btn-start-icon"
                />
              </template>
            </button>
          <!-- Fim Botão Iniciar consultar -->

          <patient-details
            v-if="!fn_IS_MOBILE()"
            :doctor="doctor"
            :patient="patient"
            :appointment="appointment"
            :appointments="appointments"
            :hasAppointment="hasAppointment"
            :show-medical-record-controls.sync="showMedicalRecordControls"
          />

        </header>
        <main>
          <transition name="fade_right" mode="out-in" v-if="appointment">
            <section v-if="selectedComponent === 'medicalRequest'" class="medical_request"  id="selected_component">
              <ul class="tab">
                <li
                  class="tab-item"
                  v-for="(tab, index) in medicalRequestTabs"
                  :class="(medicalRequestSelected === index) ? 'active' : ''"
                  :key="tab.component"
                >
                  <a @click="guardTab(index)">{{ tab.name }}</a>
                </li>
              </ul>
              <transition name="fade_up">
                <component
                  :ref="medicalRequestTabs[medicalRequestSelected].component"
                  :is="medicalRequestTabs[medicalRequestSelected].component"
                  :patient="patient"
                  :doctor="doctor"
                  :agenda_id="appointment.id"
                  :key="selectedComponent"
                  :appointment-started.sync="appointmentStarted"
                  :selected-evaluation.sync="selectedEvaluation"
                  :appointment.sync="appointment"
                  :customAnamnesis.sync="anamnesisId"
                  :is-medical-history-visible.sync="isMedicalHistoryVisible"
                  :agenda.sync="agenda"
                  @reload="init()"
                  @update="setClinicalEvaluation"
                ></component>
              </transition>
            </section>
            <component
              v-else
              id="selected_component"
              :ref="selectedComponent"
              :is="selectedComponent"
              :patient="patient"
              :doctor="doctor"
              :agenda_id="appointment.id"
              :key="selectedComponent"
              :appointment-started.sync="appointmentStarted"
              :selected-evaluation.sync="selectedEvaluation"
              :appointment.sync="appointment"
              :customAnamnesis.sync="anamnesisId"
              :is-medical-history-visible.sync="isMedicalHistoryVisible"
              :agenda.sync="agenda"
              @reload="init()"
              @update="setClinicalEvaluation"
            ></component>
          </transition>
          <transition name="fade">
            <evaluations
              v-if="selectedComponent === 'evaluations' || selectedComponent === 'clinicalEvaluation'"
              :key="'evaluations'"
              @select-evaluation="selectedEvaluation = $event"
              :selected-component="selectedComponent"
              :evaluations.sync="appointments"
              :appointment-started="appointmentStarted"
              :is-medical-history-visible.sync="isMedicalHistoryVisible"
              :has-appointment.sync="hasAppointment"
              :doctor.sync="doctor"
              :patient.sync="patient"
              @update="setClinicalEvaluation"
            ></evaluations>
          </transition>
        </main>
      </section>
    </div>
    <div class="loader" v-else>
      <br />
      <dr-loader size="lg"></dr-loader>
      <br />
    </div>

    <return-confirmation-popup
      v-if="isHealthplace && shouldShowReturnConfirmation"
      :agenda-id="appointment.id"
    />
  </article>
</template>

<script>
import submenu from '@/components/layout/appointments/submenu'
import evaluations from '@/components/layout/appointments/evaluations'
import clinicalEvaluation from '@/components/layout/appointments/clinicalEvaluation'
import selfEvaluation from '@/components/layout/appointments/selfEvaluation'
import anamnesis from '@/components/layout/appointments/anamnesis'
import sickNote from '@/components/layout/appointments/sickNote'
import medicalPrescription from '@/components/layout/appointments/medicalPrescription'
import exams from '@/components/layout/appointments/exams'
import patientDetails from '@/components/layout/appointments/patientDetails'
import patientGrade from '@/components/layout/appointments/patientGrade'
import patientFinish from '@/components/layout/appointments/patientFinish'
import files from '@/components/layout/appointments/files'
import drTimer from '@/components/timer'
import EventBus from '@/globals/eventBus'
import { mapGetters } from 'vuex'
import appointmentReminder from '@/components/layout/appointments/appointmentReminder'
import returnConfirmationPopup from './returnConfirmationPopup.vue'

export default {
  name: 'DrPatientDetails',

  props: ['doctor'],

  components: {
    submenu,
    clinicalEvaluation,
    selfEvaluation,
    anamnesis,
    evaluations,
    medicalPrescription,
    sickNote,
    exams,
    patientDetails,
    patientGrade,
    patientFinish,
    files,
    drTimer,
    appointmentReminder,
    returnConfirmationPopup
  },

  data () {
    return {
      EventBus,
      // telemedicineButton: false,
      hideTelemedicineButton: null,
      telemedicineToken: null,
      broadCasting: false,
      medicalRequestTabs: [
        {
          name: 'Receitas',
          component: 'medicalPrescription'
        },
        {
          name: 'Exames',
          component: 'exams'
        }
      ],
      medicalRequestSelected: 0,
      loaded: false,
      appointmentStarted: false,
      startTimer: null,
      selectedComponent: 'receipt',
      localTimer: {
        hours: 0,
        minutes: 0,
        seconds: 0
      },
      hasAppointment: false,
      selectedEvaluation: null,
      nextAppointment: null,
      appointments: [],
      appointment: null,
      appointmentFinished: false,
      anamnesisId: null,
      patient: {},
      agenda: null,
      loading: false,
      loadingTelemedicine: false,
      shouldShowReturnConfirmation: false
    }
  },

  computed: {
    ...mapGetters({
      getTelemedicineActive: 'getTelemedicineActive',
      getAppointmentStart: 'getAppointmentStart',
      isCertificateExpired: 'getNewCertifierCredentialRequired'
    }),

    shouldBlockStartAppointment () {
      if (this.appointment) {
        return /^(?=.*healthplace)(?=.*telemedicin(e|a)).+/gim.test(this.appointment.type) &&
          this.isCertificateExpired
      }

      return false
    },

    isHealthplace () {
      return this.appointment && /(healthplace)/gmi.test(this.appointment.type)
    },

    isDisabled () {
      if (this.getAppointmentStart) {
        return true
      } else {
        if (this.loading || !this.loaded) {
          return true
        }

        return false
      }
    },

    showMedicalRecordControls () {
      if (this.$route.params.patientType === 'patient') {
        return false
      }

      if (
        this.appointment &&
        this.appointment.id &&
        this.appointmentStarted &&
        !this.appointmentFinished
      ) {
        return false
      }

      return true
    },

    canStart () {
      if (
        this.appointment &&
        this.appointment.id &&
        (
          /aberto/gi.test(this.appointment.status) ||
          /aguardando confirmação pelo paciente/gi.test(this.appointment.status) ||
          /andamento/gi.test(this.appointment.status)
        )
      ) {
        return true
      }

      return false
    },

    telemedicineButton () {
      if (!this.appointment) {
        return false
      }

      if (
        /telemedicina/gi.test(this.appointment.type) &&
        this.appointmentStarted &&
        !this.getTelemedicineActive &&
        this.isActiveAppointment
      ) {
        return true
      }

      return false
    },

    isActiveAppointment () {
      if (
        this.$store.getters.getActiveAppointments.length > 0 &&
        this.$store.getters.getActiveAppointments[0].id === this.appointment.id
      ) {
        return true
      }

      return false
    },

    getTimer () {
      function addZero (v) {
        return v < 10 ? '0' + v : v
      }
      if (this.timer) {
        return `${addZero(this.timer.hours)}:${addZero(this.timer.minutes)}:${addZero(this.timer.seconds)}`
      }
      return null
    },
    getIconFill () {
      return this.appointmentStarted ? 'green' : 'blue'
    },
    isMedicalHistoryVisible () {
      if (this.$route.params.patientType === 'patient') {
        const msgNotAllowed = 'O paciente não autorizou a exibição do histórico médico para essa consulta.'
        if (this.appointment !== null) {
          const hasSharedMedicalHistory = !!this.appointment.is_share_medical_history
          const msg = !hasSharedMedicalHistory ? msgNotAllowed : null

          return { status: hasSharedMedicalHistory, msg }
        }
      }
      return { status: true, msg: null }
    }
  },

  watch: {
    timer: {
      immediate: false,
      deep: true,
      handler () {
        this.localTimer = this.timer
      }
    },

    '$route.params.agendaId': function (next, prev) {
      if (this.loaded) {
        this.loaded = false
        this.$forceUpdate()
        this.init()
      }
    }

  },

  created () {
    EventBus.$on('telemedicine-started', () => {
      console.log('Telemedicine started ...')
      this.broadCasting = true
    })

    EventBus.$on('telemedicine-finish', () => {
      console.log('Telemedicine finished ...')
      this.broadCasting = false
    })

    EventBus.$on('update', (formdata) => {
      console.log('formdata is', formdata)
    })
  },

  mounted () {
    this.init()
    if (this.getAppointmentStart) {
      this.appointmentConfirm()
    }
  },

  destroyed () {
    this.hideTelemedicineButton = null
  },

  methods: {
    init () {
      this.fn_SHOW_PROGRESS()

      this.loaded = false
      this.appointmentStarted = false
      this.startTimer = null
      this.selectedComponent = 'evaluations'
      this.localTimer = {
        hours: 0,
        minutes: 0,
        seconds: 0
      }
      this.hasAppointment = false
      this.selectedEvaluation = null
      this.appointments = []
      this.appointment = null
      this.appointmentFinished = false
      this.patient = null

      let type = this.$route.params.patientType === 'specialPatient' ? 'special_patient' : 'patient'
      let url = this.fn_IS_SECRETARY()
        ? `/secretary/doctor/${this.$route.params.doctorId}/${type}/${this.$route.params.id}?order[a.appointmentStart]=DESC`
        : `/${this.fn_GET_PARENT_ROUTE(this.$route)}/${type}/${this.$route.params.id}?order[a.appointmentStart]=DESC`
      // console.log(url)
      this.$http.get(url, this.$store.getters.getAuthHeader).then(
        (res) => {
          const patient = res.data.patient || res.data
          let appointments = []
          // this.appointments = appointments
          for (let appointment of (res.data.appointments || res.data.agenda || res.data.agendas)) {
            if (this.$moment().diff(appointment.appointment_start, 'hours') <= 0 && !this.nextAppointment && !appointment.medical_consultation_start) {
              this.nextAppointment = appointment
            }
            if (((appointment.medical_consultation_start && !appointment.medical_consultation_finish) || (this.$moment(appointment.appointment_start).parseZone().format('YYYY-MM-DD') === this.$moment(new Date()).format('YYYY-MM-DD'))) && appointment.status.indexOf('CANCELADO') === -1) {
              this.hasAppointment = true
              if (this.appointment) {
                if (parseInt(this.$route.params.agendaId) === appointment.id) {
                  this.appointment = appointment
                } else if (this.appointment.appointment_start > appointment.appointment_start && !parseInt(this.$route.params.agendaId)) {
                  this.appointment = appointment
                }
              } else {
                this.appointment = appointment
              }
              for (let active of this.$store.getters.getActiveAppointments) {
                if (active.id === parseInt(this.$route.params.agendaId)) {
                  if (appointment.medical_consultation_start) {
                    // let finish = this.$moment(appointment.medical_consultation_finish || new Date()).format()
                    // let start = this.$moment(appointment.medical_consultation_start).format()
                    // let timer = this.$moment(finish).diff(start, 'seconds')
                    // let hours = Math.floor(timer / 3600)
                    // let minutes = Math.floor(timer / 60 - (hours * 60))
                    // let seconds = Math.floor(timer - (hours * 3600) - (minutes * 60))
                    // this.timer = {
                    //   hours,
                    //   minutes,
                    //   seconds
                    // }
                    if (!appointment.medical_consultation_finish) {
                      this.appointmentStarted = true
                      this.selectedComponent = 'clinicalEvaluation'
                    }
                  }
                }
              }
            }
            if (appointment.medical_consultation_finish && appointment.status === 'REALIZADO') {
              // } else if (parseInt(this.$moment(appointment.appointment_start).parseZone().format('YYYYMMDD')) < parseInt(this.$moment(new Date()).format('YYYYMMDD'))) {
              appointments.push(appointment)
            }
          }

          this.appointments = appointments.sort((a, b) => {
            return this.$moment(b.appointment_start).valueOf() - this.$moment(a.appointment_start).valueOf()
          })
          this.patient = patient
          this.loaded = true
          this.fn_HIDE_PROGRESS()
        }
      ).catch(
        (err) => {
          if (err !== 'canceled') {
            this.fn_HIDE_PROGRESS()
            this.$store.dispatch('setModalAlert', {
              title: 'Erro',
              body: err,
              size: 'md',
              active: true,
              callback (next) {
                this.$router.push(`/doctor/${this.fn_GET_PARENT_ROUTE(this.$route, this.fn_GET_PARENT_ROUTE(this.$route, null, true))}`)
              }
            })
          }
        }
      )

      if (this.$route.params.agendaId) {
        this.$http
          .get(
            `/doctor/agenda?filterAnd[a.id]=${this.$route.params.agendaId}`,
            this.$store.getters.getAuthHeader
          )
          .then((res) => {
            this.agenda = res.data.data[0]
          })
      }
    },

    appointmentConfirm () {
      if (this.shouldBlockStartAppointment) {
        this.$store.dispatch('setModalConfirm', {
          title: 'Atenção',
          body: `Antes de iniciar essa consulta, você precisa validar seu certificado
            de assinatura digital. Isso é importante para que o paciente possa utilizar
            os documentos gerados por você nesta consulta.`,
          confirmText: 'Certificado digital',
          cancelText: 'Cancelar',
          beforeClose: (v) => {
            if (v) {
              this.$router.push({ name: 'DoctorUserCertificates' })
            }

            this.$store.dispatch('setModalConfirm')
          },
          size: 'md',
          active: true
        })
        return
      }

      const self = this
      let msg = this.appointmentStarted ? `Tem certeza que deseja encerrar essa consulta?` : `Tem certeza que deseja iniciar essa consulta?`
      EventBus.$emit('telemedicine-zindex', { zIndex: 1 })
      this.$store.dispatch('setModalConfirm', {
        title: 'Confirmação',
        body: msg,
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        beforeClose (v) {
          if (v) {
            self.toggleAppointment()
            EventBus.$emit('telemedicine-zindex', { zIndex: 2000 })
          } else {
            if (self.getAppointmentStart) {
              self.$router.push({ name: 'DoctorAgenda' })
            }
          }
          self.$store.dispatch('setAppointmentStart', false)
          self.$store.dispatch('setModalConfirm')
        },
        size: 'md',
        active: true
      })
    },

    startAppointment () {
      let appointment = this.appointment
      let type = this.$route.params.patientType === 'specialPatient' ? 'specialPatient' : 'patient'
      appointment.patientType = type
      appointment.medical_consultation_start = this.$moment(new Date()).format()
      appointment.user = { id: this.patient.id }

      this.loading = true
      this.$http
        .get(`/agenda/${this.appointment.id}/start`, this.$store.getters.getAuthHeader)
        .then((res) => {
          this.$emit('refresh', true)
          this.$store.dispatch('setActiveAppointments', [appointment])
          this.appointmentStarted = true
          this.selectedComponent = 'clinicalEvaluation'
          this.appointmentStarted = true
          this.fn_HIDE_PROGRESS()
        })
        .catch((err) => {
          this.$store.dispatch('setModalAlert', {
            title: 'Erro',
            body: err,
            size: 'md',
            active: true
          })
        })
        .finally(() => {
          this.loading = false
          this.fn_HIDE_PROGRESS()
        })
    },

    async toggleAppointment () {
      if (!this.appointmentStarted) {
        this.nextAppointment = null
        this.fn_SHOW_PROGRESS()

        // check if new soluti cess certifier credential is required
        const isNewCredentialRequired = await this.getCertifierCredentialStatus()

        if (isNewCredentialRequired) {
          // obs.: doctor may proceed without new credential. it's optional.
          this.$store.dispatch('setModalConfirm', {
            title: 'Aviso',
            body: 'Para assinar digitalmente os arquivos nesse consulta, voccê precisa renovar o seu token',
            confirmText: 'Renovar agora',
            cancelText: 'Mais tarde',
            beforeClose: (v) => {
              if (v) {
                this.$router.push('/doctor/user/certificate')
                this.$store.dispatch('setModalConfirm')
              } else {
                this.startAppointment()
              }
              this.$store.dispatch('setModalConfirm')
            },
            size: 'md',
            active: true
          })
        } else {
          this.startAppointment()
        }
      } else {
        EventBus.$emit('telemedicine-finish')

        this.loading = true
        this.$http
          .get(`/agenda/${this.appointment.id}/stop`, this.$store.getters.getAuthHeader)
          .then((res) => {
            this.$emit('refresh', true)
            this.$store.dispatch('setActiveAppointments', null)
            this.appointmentFinished = true
            this.appointmentStarted = false
            if (this.appointment.type === 'CONVENIO') {
              this.$router.push({name: 'DoctorAppointmentsList'})
            } else if (/particular/gi.test(this.appointment.type)) {
              this.selectedComponent = 'patientFinish'
            } else {
              this.selectedComponent = 'patientGrade'
            }
            this.appointmentStarted = false
            this.$store.dispatch('setModalConfirm')
            this.shouldShowReturnConfirmation = true
          })
          .catch(err => console.log(err))
          .finally(() => (this.loading = false))
      }
    },

    selectComponent (component, anamnesisId = null) {
      this.$nextTick(() => {
        const next = () => {
          this.selectedComponent = component
          this.anamnesisId = anamnesisId
          if (this.fn_IS_MOBILE()) {
            setTimeout(() => {
              document.getElementById('selected_component').scrollIntoView({ behavior: 'smooth' })
            }, 500)
          }
        }

        const section = this.selectedComponent === 'medicalRequest'
          ? this.medicalRequestTabs[this.medicalRequestSelected].component
          : this.selectedComponent

        if (
          section !== 'evaluations' &&
          this.selectedComponent !== 'evaluations' &&
          this.$refs[section].hasUnsavedData()
        ) {
          EventBus.$emit('pause-autosave')

          this.$store.dispatch('setModalConfirm', {
            title: 'Confirmação',
            body: 'Este formulário tem informações que não foram salvas. Deseja salvar?',
            confirmText: 'Salvar',
            cancelText: 'Sair sem salvar',
            beforeClose: (v) => {
              if (v) {
                EventBus.$emit(`submit-${section}`, { nextSection: section })
                this.$store.dispatch('setModalConfirm')
                return
              }

              next()
              this.$store.dispatch('setModalConfirm')

              EventBus.$emit('resume-autosave')
            },
            size: 'md',
            active: true
          })
        } else {
          next()
        }
      })
    },

    guardTab (index) {
      const section = this.medicalRequestTabs[this.medicalRequestSelected].component

      if (this.$refs[section].hasUnsavedData()) {
        this.$store.dispatch('setModalConfirm', {
          title: 'Confirmação',
          body: 'Este formulário tem informações que não foram salvas ainda. Deseja prosseguir sem salvar?',
          confirmText: 'Confirmar',
          cancelText: 'Cancelar',
          beforeClose: (v) => {
            if (v) {
              this.medicalRequestSelected = index
            }
            this.$store.dispatch('setModalConfirm')
          },
          size: 'md',
          active: true
        })
      } else {
        this.medicalRequestSelected = index
      }
    },

    startTelemedicineAppointment () {
      const url = `/agenda/${this.appointment.id}/agenda_telemedicine/start`

      this.loadingTelemedicine = true
      this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then((res) => {
          const { data } = res
          const tokens = data['agenda_telemedicines'] || null

          if (tokens) {
            this.telemedicineToken = tokens[tokens.length - 1]['telemedicine_tokens']
              .find(token => token['user_type'] === 'DOCTOR')
              .token

            EventBus.$emit(
              'start-telemedicine-appointment',
              {
                // token: this.$route.query.token,
                token: this.telemedicineToken,
                path: this.$route.path
              }
            )
            // EventBus.$emit('attach-telemedicine-screen')
          }
        })
        .catch(err => console.log(err))
        .finally(() => (this.loadingTelemedicine = false))
    },

    getCertifierCredentialStatus () {
      return this.$http.get(`/doctor/soluti_cess/credential?order[u.createdAt]=DESC&itensPerPage=1`, this.$store.getters.getAuthHeader)
        .then(({ data }) => {
          if (data.data && data.data.length) {
            // take the last credential
            const credentialExpiration = data.data[data.data.length - 1].credentialExpiresAt

            const expirationDate = this.$moment(credentialExpiration)
            const nowDate = this.$moment(new Date())

            const diff = nowDate.diff(expirationDate, 'hours')

            if (diff <= -2) {
              this.$store.dispatch('setNewCertifierCredentialRequired', false)
              return false
            }
          }

          this.$store.dispatch('setNewCertifierCredentialRequired', true)
          return true
        })
        .catch(() => {
          // In this case, Doctor doesnt have an integration (or it`s an error)
          this.$store.dispatch('setNewCertifierCredentialRequired', false)
          return false
        })
    },

    setClinicalEvaluation (formData) {
      this.appointment['main_complaint'] = formData.mainComplaint
      this.appointment['final_diagnostic'] = formData.finalDiagnostic
      this.appointment['diagnostic_analysis'] = formData.diagnosticAnalysis
      this.appointment['diagnostic_hypothesis'] = formData.diagnosticHypothesis
    }
  }
}
</script>
